import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Container, { Modal, Header, Socials } from './styles';

const ShareWithlistModal = ({ isModalOpen, toggleModal }) => {
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  });
  const handleClick = () => {
    toggleModal();
  };

  return (
    <Container isModalOpen={isModalOpen}>
      <Modal>
        <Header>
          <h3>Partager ma wishlist</h3>
          <CloseIcon
            onClick={handleClick}
            className="primaryPeach cursor-pointer"
            style={{
              margin: '0.5rem',
            }}
          />
        </Header>
        <Socials>
          <div>
            <div style={{ background: 'hsl(203, 89%, 53%)' }}>
              <TwitterIcon className="defaultWhite" fontSize="large" />
            </div>
            <p>Twitter</p>
          </div>
          <div>
            <div style={{ background: 'hsl(349, 75%, 57%)' }}>
              <InstagramIcon className="defaultWhite" fontSize="large" />
            </div>
            <p>Instagram</p>
          </div>
          <div>
            <div style={{ background: 'hsl(214, 89%, 52%)' }}>
              <FacebookIcon className="defaultWhite" fontSize="large" />
            </div>
            <p>Facebook</p>
          </div>
          <div>
            <div style={{ background: 'hsl(0, 79%, 72%)' }}>
              <FileDownloadIcon className="defaultWhite" fontSize="large" />
            </div>
            <p>Enregistrer l&apos;image</p>
          </div>
        </Socials>
      </Modal>
    </Container>
  );
};

ShareWithlistModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
};

export default ShareWithlistModal;
